import {SolutionResponse} from './solution-support.types';
import {APIService} from '@/services/api.service';
import {IProblem} from '@mobi-components/global-solution';

interface SolutionResponseWithProblem extends SolutionResponse {
  problem: IProblem;
}

export async function getProblemFromBackend(problemId: string, solutionId: string): Promise<IProblem> {
  const problemResponse = await APIService.get<SolutionResponseWithProblem>(`solution`, {
    params: {
      solution_id: solutionId,
      problem_id: problemId,
    },
  });
  return problemResponse.problem;
}

export async function submitProblem(problem: IProblem): Promise<SolutionResponse> {
  return APIService.post<SolutionResponse>(`problem`, problem);
}
